<!-- 结算管理 -->
<template>
<div>
    <div class="index">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

        <div>
            <el-form :inline="true" :model="queryParams" label-width="70px" class="form-box">
                <el-form-item label="">
                    <el-select v-model="queryParams.month" clearable @clear="searchFun()" placeholder="选择学年学期" class="label">
                        <el-option v-for="item in monthList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
					<!-- <el-button type="primary" style="margin-left:20px" size="small" @click='exportFun()'>导出</el-button> -->
                </el-form-item>
            </el-form>

            <!-- 校内教师 -->
            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="month" label="月份" align="center">
                    </el-table-column>
					<el-table-column prop="aa" label="缴费总额" align="center">
                    </el-table-column>
                    <el-table-column prop="course_all" label="课程总数" align="center">
                    </el-table-column>
                    <el-table-column prop="wage_all" label="课时总数" align="center">
                    </el-table-column>
                    <el-table-column prop="join_num" label="参与教师数" align="center">
                    </el-table-column>
                    <el-table-column prop="school_money" label="本校教师课酬" align="center">
                    </el-table-column>
					<el-table-column prop="group_money" label="机构教师课酬" align="center">
                    </el-table-column>
					<el-table-column prop="money_all" label="教师课酬总额" align="center">
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{
        
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 2,
			queryParams: {
				month: '',
			},
			monthList:	[
				{id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
			],
			tableData: [
        
				{month:' 2月',aa:'¥41,100.00',course_all:'7',wage_all:'220',join_num:'28',school_money:'¥27,500.00',group_money:'￥6,800.00 ',money_all:'¥34,300.00'},
				{month:' 1月',aa:'¥37,500.00',course_all:'6',wage_all:'189',join_num:'24',school_money:'¥22,500.00',group_money:'￥7,500.00 ',money_all:'¥30,000.00'},
			
			],
		}
	},
	watch:{

	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
			// let res = await api.studentClassStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
        },
		exportFun(){},
	},
	mounted() {

	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
	.form-box{
		display: flex;
		justify-content: space-between;
	}
}
</style>
